/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { SettingsNavigationRow } from '../../components/SettingsNavigationRow';
import { SettingsNavListCard, SettingsSectionHeader, SettingsScreenBody } from './settingsScreenLayout';
import { spacing } from '../../../shared/theme/spacing';
import { ticketColors } from '../../../shared/theme/ticketColors'
import { PaperSheet } from '../../../shared/ticket/PaperSheet';

export type AdministrationNavRow = {
  id: string;
  title: string;
  description: string;
  onPress: () => void;
  tone: 'default' | 'accent' | 'danger';
  disabled?: boolean;
  iconName?: React.ComponentProps<typeof Ionicons>['name'];
};

export type AdministrationGroup = {
  id: string;
  label: string;
  items: AdministrationNavRow[];
};

type Props = {
  administrationGroups: AdministrationGroup[];
  /** Clean design mobile: flat groups, icon-wraps, borderSoft cards. */
  mobile?: boolean;
};

export function ProfileContentSection({ administrationGroups, mobile = false }: Props) {
  if (mobile) {
    return (
      <View style={mobileStyles.body}>
        {administrationGroups.map((group) => (
          <View key={group.id} style={mobileStyles.group}>
            <Text style={mobileStyles.groupLabel}>{group.label}</Text>
            <PaperSheet style={mobileStyles.card}>
              {group.items.map((item, index) => (
                <SettingsNavigationRow
                  key={item.id}
                  title={item.title}
                  description={item.description}
                  onPress={item.onPress}
                  tone={item.tone}
                  disabled={item.disabled}
                  iconName={item.iconName}
                  showSeparator={index < group.items.length - 1}
                />
              ))}
            </PaperSheet>
          </View>
        ))}
      </View>
    );
  }

  return (
    <SettingsScreenBody>
      {administrationGroups.map((group) => (
        <React.Fragment key={group.id}>
          <SettingsSectionHeader title={group.label} />
          <SettingsNavListCard>
            {group.items.map((item, index) => (
              <SettingsNavigationRow
                key={item.id}
                title={item.title}
                description={item.description}
                onPress={item.onPress}
                tone={item.tone}
                disabled={item.disabled}
                iconName={item.iconName}
                showSeparator={index < group.items.length - 1}
              />
            ))}
          </SettingsNavListCard>
        </React.Fragment>
      ))}
    </SettingsScreenBody>
  );
}

const mobileStyles = StyleSheet.create({
  body: {
    gap: spacing.md + 2,
    alignSelf: 'stretch',
  },
  group: {
    gap: 6,
  },
  groupLabel: {
    fontSize: 11,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    paddingLeft: 4,
    paddingBottom: 2,
  },
  card: {
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.xs,
  },
});
